import { UserOutlined } from '@ant-design/icons';
import { Descriptions, Modal, Typography } from 'antd';

import { MODAL_WIDTHS } from '@/shared/lib/constants';
import { LoadingState } from '@/shared/ui/states/LoadingState';

import type { UserProfile } from '@/entities/auth';

import styles from './UserInfoModal.module.css';

const { Title } = Typography;

type UserInfoModalProps = {
  open: boolean;
  onClose: () => void;
  userInfo: UserProfile | null;
  isLoading: boolean;
  error: string | null;
};

export const UserInfoModal: React.FC<UserInfoModalProps> = ({ open, onClose, userInfo, isLoading, error }) => {
  return (
    <Modal title={null} open={open} onCancel={onClose} footer={null} centered width={MODAL_WIDTHS.STANDARD_FORM}>
      <div className={styles.container}>
        <div className={styles.header}>
          <UserOutlined className={styles.icon} />
          <Title level={3} className={styles.title}>
            내 정보
          </Title>
        </div>

        {isLoading && (
          <div className={styles.loadingContainer}>
            <LoadingState message="사용자 정보를 불러오는 중..." />
          </div>
        )}

        {error && (
          <div className={styles.errorContainer}>
            <p className={styles.errorText}>{error}</p>
          </div>
        )}

        {!isLoading && !error && userInfo && (
          <Descriptions column={1} bordered className={styles.descriptions}>
            <Descriptions.Item label="사용자 ID">{userInfo.username}</Descriptions.Item>
            <Descriptions.Item label="이메일">{userInfo.email}</Descriptions.Item>
          </Descriptions>
        )}
      </div>
    </Modal>
  );
};
